import { render } from 'preact'
import { html } from 'htm/preact'
import { AppProvider } from './state.js'
import App from './components/App.js'

render(html`<${AppProvider}><${App} /></${AppProvider}>`, document.getElementById('app'))